import React, { useEffect, useRef, useState } from 'react';
import { ContainerRow, TitleRow, DividerStyle } from '../styledComponents';

import { billJob, getJobInfoForPrint } from '../../../Apis/Jobs';
import { ControlsDiV } from '../styledComponents';
import { PrintButton } from '../Audit/styledComponents';
import SessionDetails from './SessionDetails';
import NoteEmrPdf, { pickNotePdfLink } from '../Audit/NoteEmrPdf';
import { PrinterOutlined } from '@ant-design/icons';
import CustomSideDrawer from '../../CustomComponents/CustomSideDrawer';
import { AddButton } from './styledComponents';

import { ContentRow } from '../Editor/styledComponents';
import { useSelector } from 'react-redux';
import { Col, Dropdown, notification } from 'antd';
import { useParams } from 'react-router-dom';
import { releaseJobFromBiller, updateCptCodes } from '../../../Apis/Biller';
import {
  getDemographics,
  sectionFetch,
  getJobAttachments
} from '../../../Apis/Jobs';
import { findPatientMoreDetails } from '../../../Apis/Doctor';
import { useReactToPrint } from 'react-to-print';
import PageTitle from '../../../Utils/PageTitle';
import CustomTypography from '../../CustomComponents/CustomTypography';

import Demographics from '../Editor/Demographics';
import Spinner from '../../CustomComponents/Spinner';

import { useHistory, useLocation } from 'react-router-dom';
import BreadCrumbComponent from '../../CustomComponents/BreadCrumbComponent';
import moment from 'moment';
import {
  formatTime as formatTimeDisplay,
  formatDateTime
} from '../../../Utils/dateFormat';
import NewBillerEditorComponent from '../../CustomComponents/NewBillerEditorComponent';
import {
  getDataOfPatient,
  getCoverages,
  getContacts,
  getAllergyIntoleranceData,
  getAdvanceDirectivesConsentsData,
  getPractitionersData
} from '../../../Apis/Patient';
import MoreHorizIcon from '../../../Assets/Icons/MoreHorizIcon';
import { InfoButton } from '../NewEditor/styledComponents';

const BillerJobs = props => {
  const [theme] = useSelector(state => [state.themeReducer]);
  const { jobId } = useParams();
  // const { sessionId } = useParams('sessionId');
  const user = useSelector(state => state.userReducer);
  const audioRef = useRef();
  const selectedCodesRef = useRef([]);
  const [readOnly, setReadOnly] = useState(false);
  const [demographicsData, setDemographicsData] = useState([]);
  const [localDemographicsData, setLocalDemographicsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [billLoading, setBillLoading] = useState(false);
  const [highlightWord, setHighlightWord] = useState('');
  const [loadings, setLoadings] = useState(true);
  const [sections, setSections] = useState(null);
  const [headings, setHeadings] = useState(null);
  const [template, setTemplate] = useState('');
  const [inferenceActive, setInferenceActive] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [demographicsLoading, setDemographicsLoading] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [activeSectionContent, setActiveSectionContent] = useState('');
  const [inferenceData, setInferenceData] = useState([]);
  const [inferenceAnnotation, setInferenceAnnotation] = useState([]);
  const [saveStatus, setSaveStatus] = useState(null);
  const [changeStatus, setChangeStatus] = useState(false);

  const [jobName, setJobName] = useState('');
  const [editorLoading, setEditorLoading] = useState(true);
  const [lastUpdateTime, setLastUpdateTime] = useState(null);
  const [printInfoData, setPrintInfoData] = useState([]);
  const [printMoreData, setPrintmoreData] = useState([]);
  const [patietSection, setPatietSection] = useState([]);
  const [updateInferenceLoading, setUpdateInferenceLoading] = useState(false);
  const [editorDataPreviewValue] = useState([]);
  const [matchedCodes, setMatchedCodes] = useState([]);
  const location = useLocation();
  const [userType, setUserType] = useState('');
  const componentRef = useRef();
  const [localSectionIdMap] = useState(new Map());
  const [newInferenceActive, setNewInferenceActive] = useState(false);
  const [coverages, setCoverages] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [allergies, setAllergies] = useState([]);
  const [advanceConsents, setAdvanceConsents] = useState([]);
  const [practitioners, setPractitioners] = useState([]);

  const [jobStage, setJobStage] = useState('');
  const [refetchDemographics, setRefetchDemographics] = useState(false);
  const history = useHistory();

  // State for handling auto-assigned job release on navigation
  const [isReleasingJob, setIsReleasingJob] = useState(false);

  const [dataMap, setDataMap] = useState({});
  // { win } while the EMR Note PDF is being generated client-side.
  const [noteJob, setNoteJob] = useState(null);
  // Backend-provided note PDF file link (from /clinic/job/attachments), if any.
  const [notePdfLink, setNotePdfLink] = useState(null);

  // Look for a backend-generated note PDF up front so the "Print Note" click can
  // open it synchronously (popup-blocker safe) instead of generating one.
  useEffect(() => {
    if (!jobId) return;
    getJobAttachments(jobId)
      .then(response => {
        const list = Array.isArray(response.data)
          ? response.data
          : response.data?.result || [];
        setNotePdfLink(pickNotePdfLink(list));
      })
      .catch(err => console.log(err));
  }, [jobId]);

  // Open the tab synchronously (inside the click) so popup blockers allow it,
  // seeded with a loading spinner; the generated PDF replaces it when ready.
  const openLoadingWindow = () => {
    const win = window.open('', '_blank');
    if (win) {
      win.document.open();
      win.document.write(`
        <!doctype html><html><head><title>Generating PDF</title>
        <style>
          html,body{margin:0;height:100%}
          body{display:flex;flex-direction:column;align-items:center;justify-content:center;
            font-family:'Krub',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;
            background:#F0F2F5;color:#525E6F}
          .spinner{width:44px;height:44px;border:4px solid #E8ECF0;border-top-color:#47A4EA;
            border-radius:50%;animation:spin .8s linear infinite}
          @keyframes spin{to{transform:rotate(360deg)}}
          p{margin-top:16px;font-size:14px;font-weight:500}
        </style></head>
        <body><div class="spinner"></div><p>Generating PDF…</p></body></html>
      `);
      win.document.close();
    }
    return win;
  };

  // "Print Note": prefer the backend-generated PDF when the attachments API
  // returns a file link; otherwise generate it client-side (same generator/
  // output as the biller-audit "Note PDF" attachment).
  const handlePrintNote = () => {
    if (!jobId) return;
    if (notePdfLink) {
      window.open(notePdfLink, '_blank', 'noopener');
      return;
    }
    setNoteJob({ win: openLoadingWindow() });
  };

  // Auto-release job when navigating away if it was auto-assigned
  useEffect(() => {
    return () => {
      // Cleanup function - runs when component unmounts (user navigates away)
      const wasAutoAssigned = sessionStorage.getItem(`autoAssigned_${jobId}`);
      if (wasAutoAssigned === 'true') {
        // Call release API
        releaseJobFromBiller(jobId)
          .then(response => {
            if (response.data.success) {
              // Silently release the job
              sessionStorage.removeItem(`autoAssigned_${jobId}`);
            }
          })
          .catch(error => {
            console.error('Error releasing job:', error);
          });
      }
    };
  }, [jobId]);

  useEffect(() => {
    getEditorData();

    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    getDemographicsData();
  }, [localDemographicsData]);
  const handleBillJob = async () => {
    setBillLoading(true);
    try {
      await updateCptCodes(
        { cptCodeIds: selectedCodesRef.current.map(c => c.id), jobId },
        user.sessionId
      );
      const response = await billJob(jobId, user.sessionId);
      if (response.data.success === true) {
        notification.success({
          message: 'Success',
          description: response.data.message
        });
        sessionStorage.removeItem(`autoAssigned_${jobId}`);
        history.push('/dashboard/biller');
      } else {
        notification.error({
          message: 'error',
          description: response.data.message
        });
      }
    } catch (error) {
      console.error('Error:', error);
      notification.error({ message: 'Failed to mark job as billed' });
    } finally {
      setBillLoading(false);
    }
  };
  let BreadCrumbItems = [
    {
      name: 'Jobs',
      path: '/dashboard/biller'
    },

    {
      name: `${jobName}`
    }
  ];
  const handlePrint = useReactToPrint({
    content: () => {
      return componentRef.current;
    }
  });
  const getDemographicsData = () => {
    setDemographicsData(localDemographicsData);
  };

  useEffect(() => {}, [printMoreData]);
  useEffect(() => {
    getJobInfoForPrint(jobId)
      .then(response => {
        if (response.data.success === true) {
          setPrintInfoData(response.data.result);
          setLoadings(false);
        } else {
          notification['error']({
            message: ' Fetch Failed',
            description: response.data.message
          });
        }
        // setDemographicsLoading(false);
        // setRefetchDemographics(false);
      })
      .catch(err => {
        // setDemographicsLoading(false);
        // setRefetchDemographics(false);
        console.log(err);
        // setDemographicsLoading(false);
      });
  }, []);
  useEffect(() => {
    if (printInfoData[0]) {
      findPatientMoreDetails(
        printInfoData[0]?.facility.facilityId,
        printInfoData[0]?.patientId
      )
        .then(response => {
          if (response.data.success === true) {
            setPrintmoreData(response.data.result);
            // setLoadings(false);
          } else {
            notification['error']({
              message: 'Demographics Fetch Failed',
              description: response.data.message
            });
          }
          // setDemographicsLoading(false);
          // setRefetchDemographics(false);
        })
        .catch(err => {
          // setDemographicsLoading(false);
          // setRefetchDemographics(false);
          console.log(err);
          // setDemographicsLoading(false);
        });
    }
  }, [printInfoData]);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setUserType(searchParams.get('userType'));
    setJobStage(searchParams.get('jobStage'));

    setDemographicsLoading(true);
    getDemographics(jobId)
      .then(response => {
        if (response.data.success === true) {
          setLocalDemographicsData(response.data.result);
          setDemographicsLoading(false);
        } else {
          notification['error']({
            message: 'Demographics Fetch Failed',
            description: response.data.message
          });
          setDemographicsLoading(false);
        }
        setRefetchDemographics(false);
      })
      .catch(err => {
        console.log(err);
        setDemographicsLoading(false);
      });

    // eslint-disable-next-line
  }, [refetchDemographics]);

  useEffect(() => {
    if (printInfoData?.[0]) {
      const facilityId = printInfoData?.[0]?.facility?.facilityId;
      const patientId = printInfoData?.[0]?.patientId;
      if (!facilityId || !patientId) return;

      setLoadings(true); // Start loading earlier

      Promise.all([
        getDataOfPatient(facilityId, patientId),
        getCoverages(facilityId, patientId),
        getContacts(facilityId, patientId),
        getAllergyIntoleranceData(facilityId, patientId),
        getAdvanceDirectivesConsentsData(facilityId, patientId),
        getPractitionersData(facilityId, patientId)
      ])
        .then(
          ([
            patientRes,
            coveragesRes,
            contactsRes,
            allergyRes,
            advanceRes,
            practionerRes
          ]) => {
            let allSuccessful = true;

            if (patientRes?.data?.success) {
              setPatietSection(patientRes.data.result);
            } else {
              allSuccessful = false;
            }

            if (coveragesRes?.data?.success) {
              setCoverages(coveragesRes.data.result);
            } else {
              allSuccessful = false;
            }

            if (contactsRes?.data?.success) {
              setContacts(contactsRes.data.result);
            } else {
              allSuccessful = false;
            }

            if (allergyRes?.data?.success) {
              setAllergies(allergyRes.data.result);
            } else {
              allSuccessful = false;
            }

            if (advanceRes?.data?.success) {
              setAdvanceConsents(advanceRes.data.result);
            } else {
              allSuccessful = false;
            }

            if (practionerRes?.data?.success) {
              setPractitioners(practionerRes.data.result);
            } else {
              allSuccessful = false;
            }

            // Optionally handle failure case here
            if (!allSuccessful) {
              console.warn('One or more API responses failed.');
            }
          }
        )
        .catch(err => {
          console.error('API error:', err);
        })
        .finally(() => {
          // Always wait until Promise.all finishes completely
          setLoadings(false);
        });
    }
  }, [printInfoData]);

  const formatTime = time => {
    const savedTime = moment(time);
    const now = moment(new Date());
    const diff = now.diff(savedTime, 'hours');

    if (diff > 12) {
      return formatDateTime(savedTime);
    } else {
      return 'Today ' + formatTimeDisplay(savedTime);
    }
  };

  function processValue(value) {
    return value.replace(/<\/p>/g, '</p>\n').replace(/<\/?p>/g, '');
  }
  const getPrintData = () => {
    setDrawerVisible(true);
    setLoading(true);
    getJobInfoForPrint(jobId)
      .then(response => {
        if (response.data.success === true) {
          setPrintInfoData(response.data.result);
          setLoadings(false);
        } else {
          notification['error']({
            message: ' Fetch Failed',
            description: response.data.message
          });
        }
        // setDemographicsLoading(false);
        // setRefetchDemographics(false);
      })
      .catch(err => {
        // setDemographicsLoading(false);
        // setRefetchDemographics(false);
        console.log(err);
        // setDemographicsLoading(false);
      });
  };
  useEffect(() => {}, [patietSection]);
  const getEditorData = () => {
    setEditorLoading(true);
    sectionFetch(jobId)
      .then(response => {
        if (response.data.success) {
          for (let i = 0; i < response.data.result.length; i++) {
            const resultItem = response.data.result[i];
            for (let j = 0; j < resultItem.sections.length; j++) {
              const section = resultItem.sections[j];
              for (let k = 0; k < section.content.length; k++) {
                const contentItem = section.content[k];
                if (contentItem.type === 'Text') {
                  response.data.result[i].sections[j].content[k].value =
                    processValue(contentItem.value);
                }
              }
            }
          }
          setTemplate(response.data.templates && response.data.templates);

          setSections(
            response.data.result[0] && response.data.result[0].sections
          );

          setJobName(response.data.jobName);
          setLastUpdateTime(response.data.result[0].lastUpdatedTime);
          setEditorLoading(false);
        } else {
          notification['error']({
            message: 'Section Fetch Failed',
            description: response.data.message
          });
          setEditorLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        setEditorLoading(false);
      });
  };

  // CPT codes shown on the note PDF. matchedCodes are the codes found in the
  // note content — the same meaning as biller-audit's session.cptCodesInContent.
  const notePdfSession = {
    jobId,
    jobNumber: printInfoData?.[0]?.jobNumber,
    cptCodesInContent: matchedCodes || []
  };

  return loading && (editorLoading || demographicsLoading) ? (
    <Spinner />
  ) : (
    <>
      <PageTitle title='billerjobs' />
      {noteJob && (
        <NoteEmrPdf
          header={printInfoData?.[0]}
          patient={patietSection?.[0]}
          sections={sections || []}
          session={notePdfSession}
          targetWindow={noteJob.win}
          onComplete={() => setNoteJob(null)}
        />
      )}
      <ContainerRow gutter={[0, 40]}>
        <TitleRow justify='space-between'>
          <CustomTypography color={theme['@text-color']}>
            Review
          </CustomTypography>
          <ControlsDiV>
            <AddButton type='primary' shape='round' onClick={handlePrintNote}>
              Print Note
            </AddButton>
            <AddButton
              type='primary'
              shape='round'
              onClick={() => {
                getPrintData();
              }}
            >
              Face Sheet
            </AddButton>
            <AddButton type='primary' shape='round' onClick={handleBillJob} loading={billLoading}>
              Mark As Billed
            </AddButton>
          </ControlsDiV>
          <Col span={24}>
            <BreadCrumbComponent items={BreadCrumbItems} />
          </Col>
        </TitleRow>

        <ContentRow gutter={[24, 24]}>
          <Col span={18}>
            <NewBillerEditorComponent
              highlightWord={highlightWord}
              jobId={jobId}
              demographicsData={demographicsData}
              printInfoData={printInfoData}
              template={template}
              matchedCodes={matchedCodes}
              patietSection={patietSection ? patietSection : undefined}
              sections={sections}
              setSections={setSections}
              headings={headings}
              inferenceActive={inferenceActive}
              setInferenceActive={setInferenceActive}
              audioRef={audioRef}
              activeSection={activeSection}
              setActiveSection={setActiveSection}
              saveStatus={saveStatus}
              setSaveStatus={setSaveStatus}
              setChangeStatus={setChangeStatus}
              jobName={jobName}
              loading={editorLoading}
              inferenceAnnotation={inferenceAnnotation}
              setInferenceAnnotation={setInferenceAnnotation}
              lastUpdateTime={lastUpdateTime}
              setLastUpdateTime={setLastUpdateTime}
              // saveTimeFormat={saveTimeFormat}
              // setEditorDataPreviewValue={setEditorDataPreviewValue}
              // setEditorData={setEditorData}
              setEditorLoading={setEditorLoading}
              formatTime={formatTime}
              activeSectionContent={activeSectionContent}
              setActiveSectionContent={setActiveSectionContent}
              viewOnly={false}
              localSectionIdMap={localSectionIdMap}
              newInferenceActive={newInferenceActive}
              setNewInferenceActive={setNewInferenceActive}
              setRefetchDemographics={setRefetchDemographics}
            />
          </Col>
          <Col span={6}>
            <Demographics
              sections={sections}
              matchedCodes={matchedCodes}
              setMatchedCodes={setMatchedCodes}
              theme={theme}
              editorData={editorDataPreviewValue}
              content={demographicsData}
              inference={inferenceActive}
              jobId={jobId}
              loading={demographicsLoading}
              setHighlightWord={setHighlightWord}
              highlightWord={highlightWord}
              readOnly={readOnly}
              selectedCodesRef={selectedCodesRef}
            />
          </Col>
        </ContentRow>
        <CustomSideDrawer
          title={'Session Details'}
          placement='right'
          closable={false}
          onClose={() => {
            // setSelectedSession(null);
            setDrawerVisible(false);
          }}
          visible={drawerVisible}
          width={800}
          destroyOnClose={true}
        >
          <SessionDetails
            printInfoData={printInfoData}
            printMoreData={printMoreData?.medDiagonsis}
            // patietSection={patietSection ? patietSection : undefined}
            patietSection={patietSection ? patietSection : undefined}
            coverages={coverages ? coverages : undefined}
            contacts={contacts ? contacts : undefined}
            allergies={allergies ? allergies : undefined}
            advanceConsents={advanceConsents ? advanceConsents : undefined}
            practitioners={practitioners ? practitioners : undefined}
            loading={loadings}
            setLoading={setLoading}
            jobName={jobName}
            ref={componentRef}
          />
          <div>
            <PrintButton icon={<PrinterOutlined />} onClick={handlePrint}>
              Print
            </PrintButton>
          </div>
        </CustomSideDrawer>
      </ContainerRow>
    </>
  );
};

export default BillerJobs;
